(function ( $ ){

	MP.paginate_category = function(){

		var window_offset = 0;

		var pageNumber = 1,
			btn = $("#more_posts"),
			load_to = $('#loaded_by_ajax'),
			loaded = $('#onload_posts'),
			has_more = true,
			speed = 500;
			
		function load_posts(post_type,posts_per_page,taxonomy,taxonomy_term,author,show_author,btn ){
			
			var query_string = 	'action=more_post_ajax&postType=' + post_type + '&postsPerPage=' + posts_per_page + '&pageNumber=' +
								pageNumber + '&taxonomy=' + taxonomy + '&taxonomy_term=' + taxonomy_term + '&author=' + author+ '&show_author=' + show_author;
			
			pageNumber++;
			

			$.ajax({
				type: "POST",
				dataType: "html",
				url: ajaxurl,
				data: query_string,
				success: function(data){ 

					var $data = $(data);

					requestAnimationFrame(lazy_load)

					if($data.length){

						load_to.append($data);

						//console.log(load_to.find('.box').length );
						//console.log( $data.data('count') - posts_per_page);

						if ( load_to.find('.box').length >= $data.data('total') - posts_per_page ) {
							btn.hide();
						}

					} else{
						btn.attr("disabled",true);
					}
					btn.removeClass('loading');

				},
				error : function(jqXHR, textStatus, errorThrown) {
				//	$loader.html(jqXHR + " :: " + textStatus + " :: " + errorThrown);
				}
			});
			return false;
		}


		btn.on("click",function(){ 
			var it = $(this);
		//	it.attr("disabled",true);
			var post_type = it.data('postType');
			var posts_per_page = it.data('postsPerPage');
			var taxonomy = it.data('taxonomy');
			var taxonomy_term = it.data('taxonomy-term');
			var author, show_author;

			if ( it.data('author') ) {
				author = it.data('author');
			} else {
				author = false;
			}

            if ( it.data('show_author') ) {
                show_author = it.data('show_author');
            } else {
                show_author = false;
            }

			load_posts(post_type,posts_per_page,taxonomy,taxonomy_term,author,show_author,it);
			it.addClass('loading');
			
		});	

		if( $('.box-asset').length >= btn.data('term-count') ){	
			btn.attr("disabled",true);
		}


		window.addEventListener('load',function(){
			document.body.scrollTop = window.pageYOffset + 1;
			setTimeout(function(){
				document.body.scrollTop =  window.pageYOffset - 1; 
				
			});
		});

		var allowScrollClick = true;

		btn[0] && window.addEventListener('scroll', function(){
			if ( lib.isScrolledIntoView(btn[0])){
				allowScrollClick && btn.trigger('click');
				allowScrollClick = false;
			} else {
				allowScrollClick = true;
			}
		});

	};
	
  
})( window.jQuery );




// WEBPACK FOOTER //
// ./assets/js/c-paginate-category.js